<template>
  <div class="container py-5">
    <h2 class="mb-4 text-center fw-bold">Încărcări documente</h2>
    <div class="d-flex justify-content-center gap-3 flex-wrap">
      <button v-for="btn in buttons" :key="btn.id" class="btn-doc" :class="{
        active: activeSection === btn.id,
        minimized: activeSection
      }" @click="toggleSection(btn.id)">
        <span class="emoji">{{ btn.icon }}</span>
        <transition name="fade">
          <span class="label">{{ btn.label }}</span>
        </transition>
      </button>
    </div>
    <transition name="fade">
      <component v-if="currentComponent" :is="currentComponent" class="mt-5" />
    </transition>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import IncarcariIesiri from './IncarcariIesiri.vue'
import IncarcariIntrari from './IncarcariIntrari.vue'
import IncarcariExtras from './IncarcariExtras.vue'
import IncarcariAlteDoc from './IncarcariAlteDoc.vue'



//import IncarcariIntrari from './IncarcariIntrari.vue'
//import IncarcariExtras from './IncarcariExtras.vue'
//import IncarcariAlteDoc from './IncarcariAlteDoc.vue'

const activeSection = ref(null)

const buttons = [
  { id: 'emise', label: 'Documente emise / vânzări', icon: '📤' },
  { id: 'primite', label: 'Documente primite / cumpărări', icon: '📥' },
  { id: 'extras', label: 'Extras de cont', icon: '🧾' },
  { id: 'alte', label: 'Alte documente', icon: '📚' }
]

function toggleSection(section) {
  if (activeSection.value === section) {
    activeSection.value = null
  } else {
    activeSection.value = section
  }
}

const currentComponent = computed(() => {
  switch (activeSection.value) {
    case 'emise':
      return IncarcariIesiri
    case 'primite':
      return IncarcariIntrari
    case 'extras':
      return IncarcariExtras
    case 'alte':
      return IncarcariAlteDoc
    default:
      return null
  }
})
</script>

<style scoped>
.container {
  max-width: 1100px;
}

.d-flex {
  flex-wrap: nowrap;
  overflow-x: auto;
}

.btn-doc {
  flex: 1;
  min-width: 180px;
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: 2px solid transparent;
  border-radius: 10px;
  transition: all 0.3s ease;
  background: #f8f9fa;
  /* Force readable text on light button background */
  color: var(--bs-gray-900, #181C32) !important;
  cursor: pointer;
  font-size: 1rem;
}

.btn-doc .emoji {
  font-size: 2rem;
  margin-bottom: 10px;
}

.btn-doc .label,
.btn-doc .emoji {
  color: inherit !important;
}

.btn-doc.active {
  background-color: #0d6efd;
  color: #fff !important;
  border-color: #0d6efd;
}

.btn-doc.minimized {
  transform: scale(0.7);
  opacity: 0.9;
  height: auto;
  min-height: 110px;
  min-width: 100px;
  padding: 10px;
}

/* Dark theme adjustments */
[data-bs-theme="dark"] .btn-doc {
  background: #2b2b40 !important;
  color: #ffffff !important;
  border-color: #323248 !important;
}

[data-bs-theme="dark"] .btn-doc.active {
  background-color: #3e97ff !important;
  border-color: #3e97ff !important;
  color: #fff !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>